import React, { Component, Fragment } from "react";

import Loader from "../../components/Loader/Loader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";

import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import CardContent from "../../components/Card/CardContent/CardContent";
import CardNavbar from "../../components/Card/CardNavbar/CardNavbar";
import Section from "../../components/Section/Section";
import Summary from "../../components/Summery/Summary";
import Brand from "../../components/Brand/Brand";
import Tabs from "../../components/Tabs/Tabs";


import "./Classification.css";
 
// const scrollPlace = React.useRef()

class Classification extends Component {
  constructor(props) {
    super(props);
    
 
    this.state = {
      isEditing: false,
      categories: [],
      summeries: [],
      isChildSummerySelected: false,
      categoriesLoading: true,
      parentCode: {},
      categoryFormLoading: false,
      functionButtonsLoading: false,
      functionButtonsEditable: false,
      error: null,
      brands: [],
      brand: [],
      type: [],
      division: [],
      warranties: [],
      warranty: [],
      sizes: [],
      size: [],
      editBrand: false,
    };
   }


  componentDidMount() {
    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
        });
      })
      .catch(this.catchError);
  }

  newResetHandler = () => {
    this.setState({
      categories: [],
      categoriesLoading: false,
      summeries: [],
      isChildSummerySelected: false,
      brands: [],
      warranties: [],
      sizes: [],
    });

    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
          categoryFormLoading: false,
          functionButtonsLoading: false,
          functionButtonsEditable: false,
          isEditing: false,
        });
      })
      .catch(this.catchError);
  };

  addCategoryParentHandler = () => {
    var parentCode = {};
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        } else {
          this.state.categories[i][index].name ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        }
      }
    }
    this.setState({
      parentCode: parentCode,
      functionButtonsLoading: true,
    });
    if (Object.keys(parentCode).length !== 0) {
      this.setState({
        functionButtonsEditable: true,
      });
    }
  };

  onEditHandler = () => {
    this.setState({
      categoryFormLoading: true,
      isEditing: true,
    });
  };

  onDeleteHandler = (data) => {
    // this.setState({ categoriesLoading: true });

    if (data.label === " برند") {
      const graphqlQuery = {
        query: `
        mutation {
          deleteBrandCategory(brandCode: ${parseInt(data.code)}, categoryCode: ${parseInt(this.state.parentCode.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          console.log(resData);
          if (resData.errors) {
            throw new Error("خطا در حذف برند!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedBrand = [...prevState.brand];
            let updatedBrands = [...prevState.brands];
            
            const brandIndex = prevState.brand.findIndex(
              (p) => p.code === data.code
            );
            updatedBrands.unshift(updatedBrand[brandIndex]);
            if (brandIndex > -1) {
              updatedBrand.splice(brandIndex, 1);
            }

            return {
              brands: updatedBrands,
              brand: updatedBrand,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });
    }
    if (data.label === " گارانتی") {
      const graphqlQuery = {
        query: `
        mutation {
          deleteWarrantyCategory(warrantyCode: ${parseInt(data.code)}, categoryCode: ${parseInt(this.state.parentCode.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          console.log(resData);
          if (resData.errors) {
            throw new Error("خطا در حذف برند!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedWarranty = [...prevState.warranty];
            let updatedWarranties = [...prevState.warranties];
            
            const warrantyIndex = prevState.warranty.findIndex(
              (p) => p.id === data.code
            );
            updatedWarranties.unshift(updatedWarranty[warrantyIndex]);
            if (warrantyIndex > -1) {
              updatedWarranty.splice(warrantyIndex, 1);
            }
            return {
              warranties: updatedWarranties,
              warranty: updatedWarranty,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });
    }
    if (data.label === " سایز") {
      const graphqlQuery = {
        query: `
        mutation {
          deleteSizeCategory(sizeCode: ${parseInt(data.code)}, categoryCode: ${parseInt(this.state.parentCode.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف برند!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedSize = [...prevState.size];
            let updatedSizes = [...prevState.sizes];
            
            const sizeIndex = prevState.size.findIndex(
              (p) => p.id === data.code
            );
            updatedSizes.unshift(updatedSize[sizeIndex]);
            if (sizeIndex > -1) {
              updatedSize.splice(sizeIndex, 1);
            }

            return {
              sizes: updatedSizes,
              size: updatedSize,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });
    }
    if (data.label === " دسته‌بندی") {
      const graphqlQuery = {
        query: `
        mutation {
          deleteDivision(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف دسته بندی!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.division];
            const postIndex = prevState.division.findIndex(
              (p) => p.code === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              division: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });
    }
    if (data.label === " نوع") {
      const graphqlQuery = {
        query: `
        mutation {
          deleteType(code: ${parseInt(data.code)})
        }
      `,
      };
      fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this.props.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(graphqlQuery),
      })
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            throw new Error("خطا در حذف نوع کالایی!");
          }
          // this.newResetHandler();
          this.setState((prevState) => {
            let updatedPosts = [...prevState.type];
            const postIndex = prevState.type.findIndex(
              (p) => p.code === data.code
            );
            if (postIndex > -1) {
              updatedPosts.splice(postIndex, 1);
            }

            return {
              type: updatedPosts,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ categoriesLoading: false });
        });
    }
  };

  fetchAllBrands = (categoryCode) => {
    const graphqlQuery = {
      query: `
        query FetchBrands($categoryCode: Int!) {
          allBrandsdata(categoryCode: $categoryCode) {             
            code
            title
            enTitle
            imageUrl              
          }
        }
      `,
      variables: {
        categoryCode: categoryCode,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            brands: resData.data.allBrandsdata,
        });
           
      })
      .catch(this.catchError);
  }

  fetchAllWarranties = (categoryCode) => {
    const graphqlQuery = {
      query: `
        query FetchWarranties($categoryCode: Int!) {
          allWarrantiesdata(categoryCode: $categoryCode) {             
            id
            title
            period
            description              
          }
        }
      `,
      variables: {
        categoryCode: categoryCode,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            warranties: resData.data.allWarrantiesdata,
        });
           
      })
      .catch(this.catchError);
  }

  fetchAllSizes = (categoryCode) => {
    const graphqlQuery = {
      query: `
        query FetchSizes($categoryCode: Int!) {
          allSizesdata(categoryCode: $categoryCode) {             
            id
            title
            sort           
          }
        }
      `,
      variables: {
        categoryCode: categoryCode,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            sizes: resData.data.allSizesdata,
        });
           
      })
      .catch(this.catchError);
  }

  onQueryHandler = (tab) => {
    let graphqlQuery;

    switch (tab) {
      case "برند کالا":
        graphqlQuery = {
          query: `
            query FetchBrands($categoryCode: Int) {
              brands(categoryCode: $categoryCode){
                code
                title
                enTitle
                imageUrl
                isActive
              }
            }
          `,
          variables: {
            categoryCode: this.state.parentCode.code,
          },
        };
        break;
      case "گارانتی کالا":
        graphqlQuery = {
          query: `
            query FetchWarranties($categoryCode: Int) {
              warranties(categoryCode: $categoryCode){
                id
                title
                period
                description
              }
            }
          `,
          variables: {
            categoryCode: this.state.parentCode.code,
          },
        };
        break;     
      case "سایز کالا":
        graphqlQuery = {
          query: `
            query FetchSizes($categoryCode: Int) {
              sizes(categoryCode: $categoryCode){
                id
                title
                sort
              }
            }
          `,
          variables: {
            categoryCode: this.state.parentCode.code,
          },
        };
        break;
      case "دسته‌بندی کالا":
        graphqlQuery = {
          query: `
            query FetchDivisions($categoryCode: Int) {
              divisions(categoryCode: $categoryCode){
                code
                title
                imageUrl
                isActive
              }
            }
          `,
          variables: {
            categoryCode: this.state.parentCode.code,
          },
        };
        break;
      case "نوع کالا":
        graphqlQuery = {
          query: `
            query FetchTypes($categoryCode: Int) {
              types(categoryCode: $categoryCode){
                code
                title
                imageUrl
                isActive
              }
            }
          `,
          variables: {
            categoryCode: this.state.parentCode.code,
          },
        };
        break;
    }

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }
        switch (tab) {
          case "برند کالا":
            this.setState({
              brand: resData.data.brands,
            });
            break;
          case "گارانتی کالا":
            this.setState({
              warranty: resData.data.warranties,
            });
            break;
          case "سایز کالا":
            this.setState({
              size: resData.data.sizes,
            });
            break;
          case "دسته‌بندی کالا":
            this.setState({
              division: resData.data.divisions,
            });
            break;
          case "نوع کالا":
            this.setState({
              type: resData.data.types,
            });
            break;
        }
      })
      .catch(this.catchError);
  };

  acceptBrandChangeHandler = (postData) => {
    // console.log(postData.editingCode);
    // if (postData.editingCode!==0) {
    //   this.setState({
    //     editBrand: resData.data.brands,
    //   });
    // }
    this.setState({
      editLoading: true,
    });
    const formData = new FormData();
    formData.append("image", postData.image);
    if (postData.oldImageUrl !== "") {
      formData.append("oldPath", postData.oldImageUrl);
    }
    fetch(process.env.REACT_APP_BACKEND_URL + "/post-image", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((fileResData) => {
        const imageUrl = fileResData.filePath || "undefined";
        let graphqlQuery;
        if (postData.editingCode !== 0) {
          if (postData.label === " دسته‌بندی") {
            graphqlQuery = {
              query: `
                mutation updatedDivision($code: Int!, $categoryCode: Int!, $title: String!, $imageUrl: String!) {
                  updateDivision(code: $code, divisionInput: {categoryCode: $categoryCode, title: $title, imageUrl: $imageUrl}) {
                    code
                    title
                    imageUrl
                    isActive
                  }
                }
              `,
              variables: {
                code: postData.editingCode,
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                imageUrl: imageUrl,
              },
            };
          }

          if (postData.label === " نوع") {
            graphqlQuery = {
              query: `
                mutation updatedType($code: Int!, $categoryCode: Int!, $title: String!, $imageUrl: String!) {
                  updateType(code: $code, typeInput: {categoryCode: $categoryCode, title: $title, imageUrl: $imageUrl}) {
                    code
                    title
                    imageUrl
                    isActive
                  }
                }
              `,
              variables: {
                code: postData.editingCode,
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                imageUrl: imageUrl,
              },
            };
          }
        } else {
          if (postData.label === " برند") {
            graphqlQuery = {
              query: `
                mutation addBrandCategory($brandCode: Int!, $categoryCode: Int!) {
                  addBrand(brandCode: $brandCode, categoryCode: $categoryCode) {
                    code
                    title
                    enTitle
                    imageUrl
                  }
                }
              `,
              variables: {
                brandCode: postData.brandCode,
                categoryCode: postData.categoryCode,
              },
            };
          }

          if (postData.label === " دسته‌بندی") {
            graphqlQuery = {
              query: `
                mutation createNewDivision($categoryCode: Int!, $title: String!, $imageUrl: String!) {
                  createDivision(divisionInput: {categoryCode: $categoryCode, title: $title, imageUrl: $imageUrl}) {
                    code
                    title
                    imageUrl
                    isActive
                  }
                }
              `,
              variables: {
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                imageUrl: imageUrl,
              },
            };
          }

          if (postData.label === " نوع") {
            graphqlQuery = {
              query: `
                mutation createNewType($categoryCode: Int!, $title: String!, $imageUrl: String!) {
                  createType(typeInput: {categoryCode: $categoryCode, title: $title, imageUrl: $imageUrl}) {
                    code
                    title
                    imageUrl
                    isActive
                  }
                }
              `,
              variables: {
                categoryCode: postData.categoryCode,
                title: postData.title,
                enTitle: postData.enTitle,
                imageUrl: imageUrl,
              },
            };
          }
        }
        

        return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
          method: "POST",
          body: JSON.stringify(graphqlQuery),
          headers: {
            Authorization: "Bearer " + this.props.token,
            "Content-Type": "application/json",
          },
        });
      })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "createType";
        if (postData.label === " برند") {
          resDataField = "addBrand";
        }
        if (postData.label === " دسته‌بندی") {
          resDataField = "createDivision";
        }
        if (postData.editingCode !== 0) {
          resDataField = "updateType";
          if (postData.label === " دسته‌بندی") {
            resDataField = "updateDivision";
          }
        }

        var post;
        if (postData.label !== " برند") {
          post= {
            code: resData.data[resDataField].code,
            title: resData.data[resDataField].title,
            imageUrl: resData.data[resDataField].imageUrl,
            isActive: resData.data[resDataField].isActive,
          };
        }
        if (postData.label === " برند") {
          post= {
            code: resData.data[resDataField].code,
            title: resData.data[resDataField].title,
            imageUrl: resData.data[resDataField].imageUrl,
            enTitle: resData.data[resDataField].enTitle,
          };
        }

        this.setState((prevState) => {
          if (postData.label === " برند") {
            let updatedBrand = [...prevState.brand];
            let updatedBrands = [...prevState.brands];

            updatedBrands = updatedBrands.filter(item => item.code !== post.code);
            updatedBrand.unshift(post);

            return {
              brands: updatedBrands,
              brand: updatedBrand,
            };
          }
          if (postData.label === " دسته‌بندی") {
            let updatedPosts = [...prevState.division];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.division.findIndex(
                (p) => p.code === post.code
              );
              updatedPosts[postIndex] = post;
            } else {
              updatedPosts.unshift(post);
            }
            return {
              division: updatedPosts,
            };
          }
          if (postData.label === " نوع") {
            let updatedPosts = [...prevState.type];
            if (postData.editingCode !== 0) {
              const postIndex = prevState.type.findIndex(
                (p) => p.code === post.code
              );
              updatedPosts[postIndex] = post;
            } else {
              updatedPosts.unshift(post);
            }
            return {
              type: updatedPosts,
            };
          }
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editBrand: false,
          editLoading: false,
          error: err,
        });
      });
  };

  acceptSizeWarrantyChangeHandler = (postData) => {
    
    this.setState({
      editLoading: true,
    });
    
    let graphqlQuery;
    
    if (postData.label === " سایز") {
      graphqlQuery = {
        query: `
          mutation addSizeCategory($sizeCode: Int!, $categoryCode: Int!) {
            addSize(sizeCode: $sizeCode, categoryCode: $categoryCode) {
              id
              title
              sort
            }
          }
        `,
        variables: {
          sizeCode: postData.sizeCode,
          categoryCode: postData.categoryCode,
        },
      };
    }

    if (postData.label === " گارانتی") {
      graphqlQuery = {
        query: `
          mutation addWarrantyCategory($warrantyCode: Int!, $categoryCode: Int!) {
            addWarranty(warrantyCode: $warrantyCode, categoryCode: $categoryCode) {
              id
              title
              period
              description
            }
          }
        `,
        variables: {
          warrantyCode: postData.warrantyCode,
          categoryCode: postData.categoryCode,
        },
      };
    }
    
    
    

    return fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      body: JSON.stringify(graphqlQuery),
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "Validation failed. Make sure the email address isn't used yet!"
          );
        }
        if (resData.errors) {
          throw new Error("ورود کاربر ناموفق!");
        }

        let resDataField = "addSize";
        if (postData.label === " گارانتی") {
          resDataField = "addWarranty";
        }

        var post;
        if (postData.label === " سایز") {
          post= {
            id: parseInt(resData.data[resDataField].id),
            title: resData.data[resDataField].title,
            sort: resData.data[resDataField].sort,
          };
        }
        if (postData.label === " گارانتی") {
          post= {
            id: parseInt(resData.data[resDataField].id),
            title: resData.data[resDataField].title,
            period: resData.data[resDataField].period,
            description: resData.data[resDataField].description,
          };
        }

        this.setState((prevState) => {
          if (postData.label === " سایز") {
            let updatedSize = [...prevState.size];
            let updatedSizes = [...prevState.sizes];

            updatedSizes = updatedSizes.filter(item => item.id !== post.id);
            updatedSize.unshift(post);

            return {
              sizes: updatedSizes,
              size: updatedSize,
            };
          }
          if (postData.label === " گارانتی") {
            let updatedWarranty = [...prevState.warranty];
            let updatedWarranties = [...prevState.warranties];

            updatedWarranties = updatedWarranties.filter(item => item.id !== post.id);
            updatedWarranty.unshift(post);
            
            return {
              warranties: updatedWarranties,
              warranty: updatedWarranty,
            };
          }
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isEditing: false,
          editBrand: false,
          editLoading: false,
          error: err,
        });
      });
  };

  onSelectHandler = (parentCode) => {
    var indexOfParent = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        this.state.categories[i][index].code === parentCode.code &&
          (indexOfParent = i);
      }
    }
    this.setState({
      categories: this.state.categories.slice(0, indexOfParent + 1),
      summeries: this.state.summeries.splice(
        indexOfParent,
        this.state.summeries.length
      ),
      categoryFormLoading: false,
      functionButtonsLoading: false,
      functionButtonsEditable: false,
    });

    var summeryName = "";
    var isChildSummerySelected = false;
    for (var j = 0; j < this.state.categories.length; j += 1) {
      for (let index = 0; index < this.state.categories[j].length; index++) {
        if (this.state.categories[j][index].code === parentCode.code) {
          summeryName = this.state.categories[j][index].name;
          if (this.state.categories[j][index].secondName) {
            summeryName =
              summeryName +
              " (" +
              this.state.categories[j][index].secondName +
              ")";
          }
          if (!this.state.categories[j][index].hasChildren) {
            isChildSummerySelected = true;
            this.fetchAllBrands(parentCode.code);
            this.fetchAllWarranties(parentCode.code);
            if (parentCode.dataTheme == 1){
              this.fetchAllSizes(parentCode.code);
            }
          }
        }
      }
    }

    if (summeryName !== "") {
      var joined = this.state.summeries.concat(summeryName);
      this.setState({
        summeries: joined,
        isChildSummerySelected: isChildSummerySelected,
      });
    }

    const graphqlQuery = {
      query: `
        query FetchSubCategories($parentCode: Int) {
          subCategories(parentCode: $parentCode){
            code  
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
      variables: {
        parentCode: parentCode.code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!!!");
        }

        if (resData.data.subCategories.length) {
          var flag = false;
          for (var i = 0; i < this.state.categories.length; i += 1) {
            flag =
              this.state.categories[i][0].code ===
              resData.data.subCategories.code
                ? true
                : false;
          }
          if (!flag) {
            this.setState({
              categories: [
                ...this.state.categories,
                resData.data.subCategories,
              ],
              categoriesLoading: false,
            });
          }
        }
      })
      .catch(this.catchError);
  };


  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />

        <Content>
          <ContentHeader
            headerAction="درج برند، نوع و دسته‌بندی کالا"
            headerDescription="اطلاعات برند، نوع و دسته‌بندی هر یک از گروه‌های کالایی را در این صفحه وارد کنید"
          />

          <Card>
            <CardContent cardTitle="مدیریت برند، نوع و دسته‌بندی">
              <section className="feed">
                {this.state.categoriesLoading && (
                  <div style={{ textAlign: "center", marginTop: "2rem" }}>
                    <Loader />
                  </div>
                )}
                {this.state.categories.length <= 0 &&
                !this.state.categoriesLoading ? (
                  <p style={{ textAlign: "center" }}>گروه کالایی وجود ندارد.</p>
                ) : null}
                <div className="mn-content-categories" id="categoriesContainer">
                  <div className="mn-content-categories__container">
                    {!this.state.categoriesLoading &&
                      this.state.categories.map((category) => (
                        <Section
                          categories={category}
                          onSelect={this.onSelectHandler.bind(this)}
                        />
                      ))}
                  </div>
                  <div className="mn-content-categories__summary">
                    <Summary
                      noneable={false}
                      summeries={this.state.summeries}
                      isChildSummerySelected={this.state.isChildSummerySelected}
                      newResetHandler={this.newResetHandler.bind(this)}
                      addCategoryParentHandler={this.addCategoryParentHandler.bind(
                        this
                      )}
                    />
                  </div>
                </div>
              </section>
            </CardContent>
          </Card>
          {this.state.functionButtonsLoading &&
            this.state.isChildSummerySelected && (
              <CardNavbar>
                <Tabs onQueryHandler={this.onQueryHandler.bind(this)}>
                  <div label="برند کالا">
                    <Brand
                      label=" برند"
                      tableData={this.state.brand}
                      brands={this.state.brands}
                      categoryCode={this.state.parentCode.code}
                      acceptPostChangeHandler={this.acceptBrandChangeHandler.bind(
                        this
                      )}
                      onDeleteDataHandler={this.onDeleteHandler.bind(this)}
                      onEditHandler={this.onEditHandler.bind(this)}
                    />
                  </div>
                  <div label="دسته‌بندی کالا">
                    <Brand
                      label=" دسته‌بندی"
                      tableData={this.state.division}
                      categoryCode={this.state.parentCode.code}
                      acceptPostChangeHandler={this.acceptBrandChangeHandler.bind(
                        this
                      )}
                      onDeleteDataHandler={this.onDeleteHandler.bind(this)}
                      onEditHandler={this.onEditHandler.bind(this)}
                    />
                  </div>
                  <div label="نوع کالا">
                    <Brand
                      label=" نوع"
                      tableData={this.state.type}
                      categoryCode={this.state.parentCode.code}
                      acceptPostChangeHandler={this.acceptBrandChangeHandler.bind(
                        this
                      )}
                      onDeleteDataHandler={this.onDeleteHandler.bind(this)}
                      onEditHandler={this.onEditHandler.bind(this)}
                    />
                  </div>
                  <div label="گارانتی کالا">
                    <Brand
                      label=" گارانتی"
                      tableData={this.state.warranty}
                      warranties={this.state.warranties}
                      categoryCode={this.state.parentCode.code}
                      acceptPostChangeHandler={this.acceptSizeWarrantyChangeHandler.bind(
                        this
                      )}
                      onDeleteDataHandler={this.onDeleteHandler.bind(this)}
                      onEditHandler={this.onEditHandler.bind(this)}
                    />
                  </div>
                  {this.state.parentCode.dataTheme == 1 && (
                    <div label="سایز کالا">
                      <Brand
                        label=" سایز"
                        tableData={this.state.size}
                        sizes={this.state.sizes}
                        categoryCode={this.state.parentCode.code}
                        acceptPostChangeHandler={this.acceptSizeWarrantyChangeHandler.bind(
                          this
                        )}
                        onDeleteDataHandler={this.onDeleteHandler.bind(this)}
                        onEditHandler={this.onEditHandler.bind(this)}
                      />
                    </div>)
                  }
                </Tabs>
              </CardNavbar>
            )}
          
        </Content>
      </Fragment>
    );
  }
}

export default Classification;
